export default "__VITE_ASSET__5My8dNqJ__"